import GeoJsonService from "@/services/api/GeoJsonService";
import { GeoJsonObject } from "geojson";
import { create } from "zustand";

const useGeoJsonShapeFiles = create<GeoJsonShapeFilesStoreStateType>()((set, get) => ({
  //geojson files
  geoJsonFiles: {},
  geoJsonObjects: {},
  fetchGeoJsonFiles: async () => {
    const response = await GeoJsonService.getGeoJsonFiles();
    const geoJsonFiles: Dic<boolean> = {};
    response.forEach((file: string) => {
      geoJsonFiles[file] = false;
    });
    set({ geoJsonFiles });
  },
  selectGeoJsonFile: async (fileName: string) => {
    const geoJsonFiles = { ...get().geoJsonFiles };
    geoJsonFiles[fileName] = !geoJsonFiles[fileName];
    set({ geoJsonFiles });

    const geoJsonObjects: Dic<GeoJSON.GeoJsonObject> = {};
    const oldGeoJsonObjects = get().geoJsonObjects;

    for (const geoJsonObjectsKey in get().geoJsonObjects) {
      if (geoJsonObjectsKey !== fileName) {
        geoJsonObjects[geoJsonObjectsKey] = oldGeoJsonObjects[geoJsonObjectsKey];
      }
    }

    if (geoJsonFiles[fileName]) {
      const geoJsonObject = await GeoJsonService.getGeoJsonFile(fileName);
      geoJsonObjects[fileName] = geoJsonObject as GeoJsonObject;
    }

    set({ geoJsonObjects });
  },
}));

export default useGeoJsonShapeFiles;
